import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/PageHeader";
import { BtnLink } from "@/components/BtnLink";
import { useT } from "@/context/LanguageContext";

const IMG_A = "https://images.pexels.com/photos/37110043/pexels-photo-37110043.jpeg?auto=compress&cs=tinysrgb&w=1600";
const IMG_B = "https://images.pexels.com/photos/34189613/pexels-photo-34189613.jpeg?auto=compress&cs=tinysrgb&w=1600";

export default function Proprietaires() {
  const t = useT().ownersPage;
  return (
    <>
      <Seo title="Conciergerie pour propriétaires à Cannes" description="Conciergerie digitale & physique pour propriétaires. Valorisation, stratégie tarifaire, Airbnb & Booking et suivi opérationnel à Cannes et en France." path="/proprietaires" />
      <PageHeader overline={t.overline} title={t.title} intro={t.intro} />
      <section className="py-20 sm:py-28 max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <Reveal><div className="img-zoom aspect-[4/5]"><img src={IMG_A} alt="Intérieur d’un logement géré par Riviera Host Collection" loading="lazy" className="w-full h-full object-cover" /></div></Reveal>
          <Reveal delay={0.1}><p className="overline text-ink/50 mb-6">{t.s1o}</p><h2 className="font-serif text-4xl sm:text-5xl leading-[1.05]">{t.s1t}</h2><p className="mt-6 text-ink/70 leading-relaxed">{t.s1d}</p></Reveal>
        </div>
      </section>
      <section className="py-20 sm:py-28 bg-ink text-ivory">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
          <Reveal><p className="overline text-gold mb-12">{t.servicesTitle}</p></Reveal>
          <div className="grid sm:grid-cols-2 gap-x-16">
            {t.services.map((s, i) => (
              <Reveal key={i} delay={(i % 2) * 0.06}><div className="flex items-baseline gap-5 py-4 border-b border-ivory/10 group"><span className="font-serif text-gold text-sm w-8 shrink-0">{String(i + 1).padStart(2, "0")}</span><span className="text-ivory/85 group-hover:text-ivory transition-colors">{s}</span></div></Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="py-20 sm:py-28 max-w-[1500px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <Reveal className="order-2 lg:order-1"><p className="overline text-ink/50 mb-6">{t.s2o}</p><h2 className="font-serif text-4xl sm:text-5xl leading-[1.05]">{t.s2t}</h2><p className="mt-6 text-ink/70 leading-relaxed">{t.s2d}</p><div className="mt-10"><BtnLink to="/confier-mon-bien" variant="solid" data-testid="proprietaires-cta">{t.cta}</BtnLink></div></Reveal>
          <Reveal delay={0.1} className="order-1 lg:order-2"><div className="img-zoom aspect-[4/5]"><img src={IMG_B} alt="Terrasse avec vue mer d’un bien de la Collection" loading="lazy" className="w-full h-full object-cover" /></div></Reveal>
        </div>
      </section>
    </>
  );
}
